// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navbar-container {
  display: flex;
  justify-content: space-between;
  padding: 16px 38px 16px 22px;
  border-bottom: 1px solid var(--dee3);
}
#navbar-container .profile-block {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2px 4px 2px 0px;
  border-radius: 15px 15px 15px 15px;
}
#navbar-container .profile-block:hover {
  transform: scale(1.025);
}
#navbar-container .dropdown-menu {
  margin-top: 5px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--e3e3);
}
#navbar-container .btn:focus-visible {
  box-shadow: unset;
}
#navbar-container #dropdown-basic {
  background-color: unset;
  border: unset;
  padding: unset;
  margin: unset;
}
#navbar-container .dropdown-toggle::after {
  display: none;
}
#navbar-container #drop-menu {
  min-width: 275px !important;
  margin-top: 10px;
}
#navbar-container .dropdown-item:active {
  background-color: var(--56ff);
  color: var(--ffff) !important;
}
#navbar-container .ju367v9c {
  background-color: var(--56ff);
}

#navbar-container-dark {
  display: flex;
  justify-content: space-between;
  padding: 16px 38px 16px 22px;
  border-bottom: 1px solid var(--4d6c);
}
#navbar-container-dark .profile-block {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2px 4px 2px 0px;
  border-radius: 15px 15px 15px 15px;
}
#navbar-container-dark .profile-block:hover {
  transform: scale(1.025);
}
#navbar-container-dark .dropdown-menu {
  margin-top: 5px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--e3e3);
  --bs-dropdown-link-hover-bg: var(--4d6c);
}
#navbar-container-dark .dropdown-menu.show {
  background-color: var(--2b4e);
  color: var(--ffff);
}
#navbar-container-dark .btn:focus-visible {
  box-shadow: unset;
}
#navbar-container-dark #dropdown-basic {
  background-color: unset;
  border: unset;
  padding: unset;
  margin: unset;
}
#navbar-container-dark .dropdown-toggle::after {
  display: none;
}
#navbar-container-dark #drop-menu {
  min-width: 275px !important;
  margin-top: 10px;
}
#navbar-container-dark .dropdown-item:active {
  background-color: var(--4d6c);
  color: var(--ffff) !important;
}
#navbar-container-dark .ju367v9c {
  background-color: var(--2b4e);
}`, "",{"version":3,"sources":["webpack://./src/pages/Layout/Navbar/Navbar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,oCAAA;AACF;AACE;EACE,2CAAA;EACA,wBAAA;EACA,kCAAA;AACJ;AAAI;EACE,uBAAA;AAEN;AACE;EACE,eAAA;EACA,2CAAA;EACA,6BAAA;AACJ;AACE;EACE,iBAAA;AACJ;AACE;EACE,uBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AACJ;AACE;EACE,aAAA;AACJ;AACE;EACE,2BAAA;EACA,gBAAA;AACJ;AACE;EACE,6BAAA;EACA,6BAAA;AACJ;AACE;EACE,6BAAA;AACJ;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,oCAAA;AAAF;AAEE;EACE,2CAAA;EACA,wBAAA;EACA,kCAAA;AAAJ;AACI;EACE,uBAAA;AACN;AAEE;EACE,eAAA;EACA,2CAAA;EACA,6BAAA;EACA,wCAAA;AAAJ;AAEE;EACE,6BAAA;EACA,kBAAA;AAAJ;AAEE;EACE,iBAAA;AAAJ;AAEE;EACE,uBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AAAJ;AAEE;EACE,aAAA;AAAJ;AAEE;EACE,2BAAA;EACA,gBAAA;AAAJ;AAEE;EACE,6BAAA;EACA,6BAAA;AAAJ;AAEE;EACE,6BAAA;AAAJ","sourcesContent":["#navbar-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 16px 38px 16px 22px;\r\n  border-bottom: 1px solid var(--dee3);\r\n\r\n  .profile-block {\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n    padding: 2px 4px 2px 0px;\r\n    border-radius: 15px 15px 15px 15px;\r\n    &:hover {\r\n      transform: scale(1.025);\r\n    }\r\n  }\r\n  .dropdown-menu {\r\n    margin-top: 5px;\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid var(--e3e3);\r\n  }\r\n  .btn:focus-visible {\r\n    box-shadow: unset;\r\n  }\r\n  #dropdown-basic {\r\n    background-color: unset;\r\n    border: unset;\r\n    padding: unset;\r\n    margin: unset;\r\n  }\r\n  .dropdown-toggle::after {\r\n    display: none;\r\n  }\r\n  #drop-menu {\r\n    min-width: 275px !important;\r\n    margin-top: 10px;\r\n  }\r\n  .dropdown-item:active {\r\n    background-color: var(--56ff);\r\n    color: var(--ffff) !important;\r\n  }\r\n  .ju367v9c {\r\n    background-color: var(--56ff);\r\n  }\r\n}\r\n\r\n#navbar-container-dark {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 16px 38px 16px 22px;\r\n  border-bottom: 1px solid var(--4d6c);\r\n\r\n  .profile-block {\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n    padding: 2px 4px 2px 0px;\r\n    border-radius: 15px 15px 15px 15px;\r\n    &:hover {\r\n      transform: scale(1.025);\r\n    }\r\n  }\r\n  .dropdown-menu {\r\n    margin-top: 5px;\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid var(--e3e3);\r\n    --bs-dropdown-link-hover-bg: var(--4d6c);\r\n  }\r\n  .dropdown-menu.show {\r\n    background-color: var(--2b4e);\r\n    color: var(--ffff);\r\n  }\r\n  .btn:focus-visible {\r\n    box-shadow: unset;\r\n  }\r\n  #dropdown-basic {\r\n    background-color: unset;\r\n    border: unset;\r\n    padding: unset;\r\n    margin: unset;\r\n  }\r\n  .dropdown-toggle::after {\r\n    display: none;\r\n  }\r\n  #drop-menu {\r\n    min-width: 275px !important;\r\n    margin-top: 10px;\r\n  }\r\n  .dropdown-item:active {\r\n    background-color: var(--4d6c);\r\n    color: var(--ffff) !important;\r\n  }\r\n  .ju367v9c {\r\n    background-color: var(--2b4e);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
